import React from 'react';
import { Helmet } from 'react-helmet-async';

/**
 * Reusable SEO Component for setting meta tags on each page
 * Usage: <SEOHelmet 
 *   title="Page Title" 
 *   description="Page description" 
 *   canonicalUrl="https://example.com/page"
 *   ogImage="image-url"
 * />
 */
const SEOHelmet = ({ 
  title, 
  description, 
  keywords = "scrap processing, recycling equipment, shredder, magnet, shear",
  canonicalUrl = "https://ramanasteels.com",
  ogImage = "%PUBLIC_URL%/logo512.png",
  ogType = "website",
  twitterCard = "summary_large_image",
  author = "Ramana Steels"
}) => {
  
  const fullTitle = title ? `${title} | Ramana Steels` : "Ramana Steels | Experts in Scrap Processing & Recycling Solutions";
  
  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="title" content={fullTitle} />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="author" content={author} />
      <meta name="robots" content="index, follow" />
      <link rel="canonical" href={canonicalUrl} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:site_name" content="Ramana Steels" />
      
      {/* Twitter */}
      <meta name="twitter:card" content={twitterCard} />
      <meta name="twitter:url" content={canonicalUrl} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
    </Helmet>
  );
};

export default SEOHelmet;
